const PIXEL_ID = '1051915437359917';
const FB_EVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: FbqFn;
    _fbq?: FbqFn;
  }
}

let initialized = false;

/**
 * Creates the fbq command queue and appends Meta's fbevents.js to <head>.
 * Written by hand instead of using a package loader: the common loaders anchor
 * the injected <script> to document.getElementsByTagName('script')[0], which is
 * undefined in environments that render the app without an inline script tag.
 */
function loadPixelScript(): FbqFn | null {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;
  if (window.fbq) return window.fbq;

  const fbq: FbqFn = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue?.push(args);
    }
  } as FbqFn;

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.push = fbq;

  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = FB_EVENTS_SRC;
  document.head.appendChild(script);

  return fbq;
}

/**
 * Initializes the Meta Pixel once and sends the initial PageView.
 * Safe to call multiple times — subsequent calls are no-ops.
 */
export function initMetaPixel(): void {
  if (initialized) return;
  const fbq = loadPixelScript();
  if (!fbq) return;

  initialized = true;
  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');
}

/**
 * Tracks the "InitiateCheckout" standard event, fired when a visitor clicks a
 * buy button right before leaving for the checkout URL.
 */
export function trackInitiateCheckout(): void {
  if (!initialized) initMetaPixel();
  window.fbq?.('track', 'InitiateCheckout');
}
